import { Phone, Mail, MapPin, Building2 } from "lucide-react";
import { CONTACT } from "../lib/shop";

const Item = ({ icon: Icon, label, value, href, testId }) => (
  <div className="flex items-start gap-4 rounded-sm border border-border bg-white p-6" data-testid={testId}>
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-primary">
      <Icon className="h-5 w-5 text-accent" />
    </div>
    <div>
      <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</div>
      {href ? (
        <a href={href} className="mt-1 block text-base font-medium text-primary hover:underline">{value}</a>
      ) : (
        <div className="mt-1 text-base font-medium text-foreground">{value}</div>
      )}
    </div>
  </div>
);

export default function ContactPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 md:px-8" data-testid="contact-page">
      <p className="text-sm font-semibold uppercase tracking-widest text-secondary">Get in touch</p>
      <h1 className="mt-2 text-4xl font-bold tracking-tight">Contact CoreConnect</h1>
      <p className="mt-3 max-w-xl text-sm text-muted-foreground">
        Questions about stock, bulk pricing or price-on-request items? We're happy to help.
      </p>

      <div className="mt-10 grid gap-4 sm:grid-cols-2">
        <Item icon={Phone} label="Phone" value={CONTACT.phone} href={`tel:${CONTACT.phone.replace(/\s+/g, "")}`} testId="contact-phone" />
        <Item icon={Mail} label="Email" value={CONTACT.email} href={`mailto:${CONTACT.email}`} testId="contact-email" />
        <Item icon={MapPin} label="Location" value={CONTACT.location} testId="contact-location" />
        <Item icon={Building2} label="ABN" value={CONTACT.abn} testId="contact-abn" />
      </div>
    </div>
  );
}
